import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/BranchManagement.css";
import axios from "axios";

import search from "/assets/icon/Search.svg";
import filter from "/assets/icon/Filter.svg";
import Delete from "/Delete.png";
import Edit from "/Edit.png";
import arrowR from "/ArrowR.png";
import Warning from "/Warning.png";
import correct from "/correct.png";

import AddBranchModal from "../../components/addBranchForm";
import UserStatus from "../../components/UserStatus";
import EditBranchModal from "../../components/EditBranchModal";

import { Typography, Box } from "@mui/material"; // นำเข้า MUI Components
import SearchOffIcon from "@mui/icons-material/SearchOff"; // นำเข้าไอคอน

function BranchManagement() {
  const [branches, setBranches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const itemsPerPage = 15;

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingBranch, setEditingBranch] = useState(null);
  const [newBranchId, setNewBranchId] = useState(null);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [branchToDelete, setBranchToDelete] = useState(null);

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleShowAlert = (message, isError = false) => {
    setAlertMessage(message);
    setIsError(isError);
    setShowAlert(true);

    setTimeout(() => {
      const alertElement = document.querySelector(".alert-container");
      if (alertElement) {
        alertElement.style.animation = "fadeOut 0.5s forwards";
      }

      setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 500);
    }, 3000);
  };

  const handleDeleteBranch = async () => {
    if (!branchToDelete) return;

    try {
      const response = await axios.delete(
        `${import.meta.env.VITE_API_URL}/branches/${branchToDelete.id}`
      );
      console.log(response.data);

      setIsDeleteConfirmOpen(false);
      setBranches((prevBranches) =>
        prevBranches.filter((branch) => branch.id !== branchToDelete.id)
      );

      handleShowAlert(`ลบสาขา ${branchToDelete.name} สำเร็จ`, false);
    } catch (error) {
      console.log('Error deleting branch:', error);
      handleShowAlert(`ไม่สามารถลบสาขา ${branchToDelete.name} ได้`, true);
    }
  };

  function DeleteConfirmationDialog({ branchName, onClose, onConfirm }) {
    return (
      <div className="BranchModal">
        <div className="BrancDeleteContent">
          <p>ยืนยันการลบสาขา '{branchName}'?</p>
          <div className="delete-confirmation-modal">
            <button onClick={onClose}>ยกเลิก</button>
            <button onClick={onConfirm}>ยืนยัน</button>
          </div>
        </div>
      </div>
    );
  }

  const navigate = useNavigate();

  const openEditModal = (branch) => {
    setEditingBranch(branch);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const goToBranchDetails = (branch) => {
    navigate("/branchdetails", { state: { branch } });
  };

  useEffect(() => {
    async function fetchBranches() {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/allbranches`);
        let branchesData = response.data;
        setBranches(branchesData);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    }

    fetchBranches();
  }, []);

  useEffect(() => {
    const filteredResults = branches.filter((branch) => {
      const search = searchTerm.toLowerCase();
      return (
        branch.code.toLowerCase().includes(search) ||
        branch.name.toLowerCase().includes(search)
      );
    });
    setFilteredBranches(filteredResults);
  }, [searchTerm, branches]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBranches.slice(indexOfFirstItem, indexOfLastItem);

  const fetchBranches = async (newId) => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/allbranches`);
      setBranches(response.data);
      if (newId) setNewBranchId(newId);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  return (
    <div className="containerPage">
      {showAlert && (
        <div>
          {!isError ? (
            <div className="BranchModal">
              <div className={`alert-container alert-success`}>
                <button
                  className="close-button"
                  onClick={() => setShowAlert(false)}
                >
                  &times;
                </button>
                {alertMessage}
                <div>
                  <img src={correct} alt="Success" />
                </div>
              </div>
            </div>
          ) : (
            <div className={`alert-container alert-error`}>
              <button
                className="close-button"
                onClick={() => setShowAlert(false)}
              >
                &times;
              </button>
              {alertMessage}
              <div>
                <img src={Warning} alt="Error" />
              </div>
            </div>
          )}
        </div>
      )}

      <br />
      <br />
      <h1 className="userManagement">การจัดการสาขา</h1>

      <div className="sectinoAddbuttom">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหาชื่อสาขา, รหัสสาขา"
            value={searchTerm}
            onChange={handleSearch}
          />

          <div>
            <img src={filter} alt="filter" className="filter-user" />
          </div>
        </div>
        <button className="add_button" onClick={openModal}>
          + เพิ่มสาขา
        </button>
      </div>

      {isModalOpen && (
        <AddBranchModal
          closeModal={closeModal}
          onSuccess={(newId) => fetchBranches(newId)}
        />
      )}
      <div className="allBranchesaEd">
        <span>มีสาขาทั้งหมด </span>
        <span className="allBranches"> {filteredBranches.length}</span>
        <span> สาขา</span>
      </div>

      <div className="branch-list-container">
        {currentItems.length === 0 ? (
          <Box
            mt={4}
            mb={4}
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
            bgcolor="#344054"
            borderRadius="8px"
            flexDirection="column"
            color="#fff"
            p={3}
          >
            <SearchOffIcon style={{ fontSize: 50, marginBottom: 16 }} />
            <Typography
              variant="h6"
              fontFamily='"IBM Plex Sans Thai", sans-serif'
              align="center"
            >
              ไม่มีข้อมูลที่ตรงกับการค้นหา
            </Typography>
          </Box>
        ) : (
          currentItems.map((branch) => (
            <div
              key={branch.id}
              className="branch-itemt "
              onClick={() => goToBranchDetails(branch)}
            >
              <div className="branch-details">
                <div className="b1">
                  {branch.id === newBranchId && (
                    <div className="new-branch-label">NEW</div>
                  )}
                  <div className="branch-name">
                    <label>สาขา</label>
                    <div className="branch-name-value">{branch.name}</div>
                  </div>

                  <div className="branch-code">
                    <label>รหัสสาขา</label>
                    <div className="branch-code-value">{branch.code} </div>
                  </div>
                </div>

                <div className="primary-pillars">
                  <strong>เสาหลัก</strong>
                  <label>เสาหลักทั้งหมด</label>
                  <div className="primary-pillars-value">
                    {branch.masterpolescount}
                  </div>
                </div>

                <div className="secondary-pillars">
                  <strong>เสารอง</strong>
                  <label>เสารองทั้งหมด</label>
                  <div className="secondary-pillars-value">
                    {branch.slavepolescount}
                  </div>
                </div>

                <div className="users">
                  <strong>ผู้ใช้งาน</strong>
                  <label>ผู้ใช้งานทั้งหมด</label>
                  <div className="users-value">{branch.usercount}</div>
                </div>

                <div className="statusBranch">
                  <UserStatus isOnline={branch.active} />
                </div>

                <div className="branch-actions">
                  <img
                    src={Edit}
                    alt="Edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      openEditModal(branch);
                    }}
                  />
                  <img
                    src={Delete}
                    alt="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      setBranchToDelete(branch);
                      setIsDeleteConfirmOpen(true);
                    }}
                  />
                </div>
                <img
                  src={arrowR}
                  alt="arrow"
                  className="arrowr"
                  onClick={() => goToBranchDetails(branch)}
                />
              </div>
            </div>
          ))
        )}

        {isDeleteConfirmOpen && branchToDelete && (
          <DeleteConfirmationDialog
            branchName={branchToDelete.name}
            onClose={() => setIsDeleteConfirmOpen(false)}
            onConfirm={handleDeleteBranch}
          />
        )}

        {isEditModalOpen && editingBranch && (
          <EditBranchModal
            branch={editingBranch}
            closeModal={closeEditModal}
            updateBranchSuccess={fetchBranches}
          />
        )}
      </div>
      <div className="sectionPagination">
        <div className="pagination">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            &laquo;
          </button>

          {Array.from({
            length: Math.ceil(filteredBranches.length / itemsPerPage),
          }).map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={currentPage === index + 1 ? "active" : ""}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={handleNextPage}
            disabled={
              currentPage === Math.ceil(filteredBranches.length / itemsPerPage)
            }
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
}

export default BranchManagement;
